export default "__VITE_ASSET__D82hlOL1__"